module.exports = __webpack_public_path__ + "img/Giraffen.b5722559.jpg";